/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {upsertShiftSchedule} from '../api'

export const useMutationUpsertShiftSchedule = createReactQueryMutationHook('upsertShiftSchedule', upsertShiftSchedule)
